'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _THHomeSearch = require('./THHomeSearch');

var _THHomeSearch2 = _interopRequireDefault(_THHomeSearch);

var _DefaultHomeSearch = require('./DefaultHomeSearch');

var _DefaultHomeSearch2 = _interopRequireDefault(_DefaultHomeSearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  HomeSearch: {
    displayName: 'HomeSearch'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Home/HomeSearch.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}
// import CSSModules from 'react-css-modules';
// import styles from './HomeSearch.scss';


// @CSSModules(styles)
var HomeSearch = _wrapComponent('HomeSearch')((_temp = _class = function (_Component) {
  (0, _inherits3.default)(HomeSearch, _Component);

  function HomeSearch() {
    (0, _classCallCheck3.default)(this, HomeSearch);
    return (0, _possibleConstructorReturn3.default)(this, (HomeSearch.__proto__ || (0, _getPrototypeOf2.default)(HomeSearch)).apply(this, arguments));
  }

  (0, _createClass3.default)(HomeSearch, [{
    key: 'render',
    value: function render() {
      if (this.props.userConfig && this.props.userConfig.selectDateEnabled) return _react3.default.createElement(_DefaultHomeSearch2.default, this.props);
      return _react3.default.createElement(_THHomeSearch2.default, this.props);
    }
  }]);
  return HomeSearch;
}(_react2.Component), _class.propTypes = {
  destinations: _react2.PropTypes.array,
  push: _react2.PropTypes.func,
  // isOpenMobileQuickSearch: PropTypes.bool,
  // openMobileQuickSearch: PropTypes.func,
  userConfig: _react2.PropTypes.object,
  messages: _react2.PropTypes.object,
  locale: _react2.PropTypes.string,
  siteConfigs: _react2.PropTypes.object,
  tourType: _react2.PropTypes.string,
  groupDestinationsByCountry: _react2.PropTypes.bool
}, _class.defaultProps = {
  destinations: {}
}, _temp));

exports.default = HomeSearch;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/HomeSearch.js
// module id = 1531
// module chunks = 47